<script lang="ts">
	export let klass =""
</script>

<div class="text-gray-500 text-xs {klass}">
	<slot></slot>
</div>